import { Component } from '@angular/core';
import * as firebase from 'firebase';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'USDJ';

  // progressBar var
  isLoaded = false;
  maxBar = 100;
  restBar = 100;
  percent= 0;


  // FIEREBASE CONFIG ////////////////////////////////////////////
  // FIEREBASE CONFIG ////////////////////////////////////////////
  // FIEREBASE CONFIG ////////////////////////////////////////////
  constructor(){
    const config = {
      apiKey: "AIzaSyD6g3eGhSSbvz2pDlXo9ukmlcK6xMbkfBo",
      authDomain: "une-somme-de-jeux-v2.firebaseapp.com",
      databaseURL: "https://une-somme-de-jeux-v2.firebaseio.com",
      projectId: "une-somme-de-jeux-v2",
      storageBucket: "une-somme-de-jeux-v2.appspot.com",
      messagingSenderId: "1008249477014"
    };
    firebase.initializeApp(config);
  }

  ngOnInit() {
    this.initLoadBar()
  }

  initLoadBar(){
    
    setInterval(()=>{
      //console.log(this.percent);
      if( this.isLoaded === false ){
        this.percent += Math​.round(this.restBar/4);
        this.restBar = this.maxBar - this.percent
      }
    },1000);

  }


 
  backgroundLoaded(){
    setTimeout(() => {
      // progressBar var actualisation
      this.percent = 100;
      this.restBar = 0;
      this.isLoaded = true;
    },3000)
  }

}

